module.exports = " <div class=session _v-1165ae04=\"\"> <title-bar _v-1165ae04=\"\"></title-bar> <router-view :relationship-sessions=relationshipSessions _v-1165ae04=\"\"></router-view> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-1165ae04!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/body/Session.vue
 ** module id = 332
 ** module chunks = 2
 **/